// 转换协议，fix：https协议下无法下载http的图片
export default (url: string) => {
    if (typeof url === 'string' && url.startsWith('http://')) {
        return url.replace(/^http:\/\//, 'https://')
    }

    return url
}
